import { Form, Formik } from 'formik';
import { useEffect, useRef } from 'react';
import { Col, Row, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Input from '../../Components/Input/Input';
import { changePasswordApi } from '../../Redux/Action/Dashboard';
import { errorNotify, successNotify } from '../../Utils/Toast';
import { changePasswordSchema } from '../../Utils/Validations';

const ChangePassword = ({setShow}) => {
  const dispatch = useDispatch();
  const { loading, changePasswordResponse, error } = useSelector((state) => state.getChangePassword);
  const formRef = useRef();

  useEffect(() => {
    if (changePasswordResponse?.statusCode === 200) {
      successNotify("Password Changed Successfully!");
      formRef.current?.resetForm();
      setShow("PROFILE");
      dispatch({ type: "CHANGE_PASSWORD_RESET" });
    }
    else if (error) {
      errorNotify(error);
      dispatch({ type: "CHANGE_PASSWORD_RESET" });
    }
  }, [changePasswordResponse, error]);

  const handleSubmit = (values) => {
    const formData = new FormData();
    formData.append('current_password', values.current_password);
    formData.append('new_password', values.new_password);
    formData.append('confirm_password', values.confirm_password);
    dispatch(changePasswordApi(formData));
  };

  return (
    <div className='profile_content'>
      <Formik
        innerRef={formRef}
        initialValues={{
          current_password: "",
          new_password: "",
          confirm_password: ""
        }}
        validationSchema={changePasswordSchema}
        onSubmit={handleSubmit}
      >
        {({ errors, touched }) => (
          <Form>
            <Row className='profile_form'>
              <Col md={4}>
                <Input
                  type="password"
                  name="current_password"
                  label="Current Password"
                  placeholder="Enter current password"
                  error={touched.current_password && errors.current_password}
                />
              </Col>
              <Col md={4}>
                <Input
                  type="password"
                  name="new_password"
                  label="New Password"
                  placeholder="Enter new password"
                  error={touched.new_password && errors.new_password}
                />
              </Col>
              <Col md={4}>
                <Input
                  type="password"
                  name="confirm_password"
                  label="Confirm Password"
                  placeholder="Confirm new password"
                  error={touched.confirm_password && errors.confirm_password}
                />
              </Col>
              <Col md={12}>
                <button
                  type="submit"
                  disabled={loading}
                  className='login_btn mt-0'
                >
                  {loading ? <Spinner animation='border' size='sm' /> : 'Submit'}
                </button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ChangePassword;
